module.exports = __webpack_public_path__ + "img/59.b2d98049.jpg";